import styled from "styled-components";

export const Container = styled.div<{positionUp?: boolean; isReady?: boolean}>`
  position: ${(props) => (props.positionUp ? "fixed" : "absolute")};
  left: ${({positionUp}) => (positionUp ? "90px;" : "70px")};
  ${(props) =>
    props.positionUp ? "bottom: 12px; top: auto;" : "top: -12px; bottom: auto;"}
  width: 300px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  /* overflow: hidden; */
  visibility: ${(props) => (props.isReady ? "visible" : "hidden")};
`;

export const FilterContainer = styled.div<{
  isactive?: string;
  disabled?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 3px;
  padding: 10px 20px;
  border-radius: 12px;
  border: 1px solid;
  border-color: ${(props) =>
    props.isactive === "true"
      ? props.disabled
        ? "#4e5574"
        : "#fff"
      : "rgba(255, 255, 255, 0.2)"};
  background-color: ${(props) =>
    props.isactive === "true"
      ? props.disabled
        ? "#335e81"
        : "#0082ED"
      : "#161A1D"};

  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover {
    border-color: ${(props) => (props.disabled ? null : "rgb(133, 136, 151)")};
  }
`;

export const ImageWrapper = styled.div<{
  isActive?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 100%;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: opacity 0.3s ease;

  user-select: none;

  .active {
    opacity: 1;
  }
`;

export const IconContainer = styled.div<{
  isActive?: boolean;
  disabled?: boolean;
  isWidthAuto?: boolean;
}>`
  width: ${(props) => (props.isWidthAuto ? "auto" : "100%")};
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  padding: 10px 20px;
  position: relative;
  min-height: 50px;
  color: ${(props) =>
    props.isActive ? "#ffffff" : "rgba(255, 255, 255, 0.7)"};
  font-size: 14px;

  border-radius: 12px;
  border: 1px solid;
  border-color: ${(props) =>
    props.isActive
      ? props.disabled
        ? "#4e5574"
        : "#fff"
      : "rgba(255, 255, 255, 0.2)"};
  background-color: ${(props) =>
    props.isActive ? (props.disabled ? "#335e81" : "#0082ED") : "#161A1D"};
  /* background-color: #272b40; */
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover {
    border-color: ${(props) => (props.disabled ? null : "rgb(133, 136, 151)")};
  }
`;

export const DescriptionWrapper = styled.div<{
  isactive?: string;
  disabled?: boolean;
}>`
  justify-content: center;
  align-items: center;
  max-height: 30px;
  margin-left: 5px;
  font-size: 12px;
  width: auto;
  max-width: 155px;
  text-align: left;
  color: #fff;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  user-select: none;

  opacity: ${(props) =>
    props.isactive === "true" ? (props.disabled ? 0.5 : 1) : 0.5};
`;
